// ---BT-107433_SrikanthRao_9-10-2023_Calculator || Functional Implementation
export const _validatePivoteValues = (obj) => {


    let objValidateWarnings = {

        openPrice: false,
        closePrice: false,
        highPrice: false,
        lowPrice: false,
        calculate: false,
    };

    try {


        if (obj.openPrice === undefined || obj.openPrice == null || obj.openPrice <= 0) {
            objValidateWarnings.openPrice = true;


        };
        if (obj.closePrice === undefined || obj.closePrice == null || obj.closePrice <= 0) {
            objValidateWarnings.closePrice = true;


        };
        if (obj.highPrice === undefined || obj.highPrice == null || obj.highPrice <= 0) {
            objValidateWarnings.highPrice = true;


        };
        if (obj.lowPrice === undefined || obj.lowPrice == null || obj.lowPrice <= 0) {
            objValidateWarnings.lowPrice = true;


        };
        return objValidateWarnings;

    } catch (error) {
        console.log("error", error);

    }

};